<script lang="ts">
    // Reproduz o comportamento do componente _common/inline-select.svelte (grupo de opções clicáveis,
    // uma ao lado da outra, com a opção ativa destacada) — mas com a estética/altura padrão do zinput
    // em vez do botão bootstrap original.
    import { createEventDispatcher } from 'svelte'
    const dispatch = createEventDispatcher()

    export let value: any = null
    export let options: { value: any; label: string; disabled?: boolean }[] = []
    export let disabled = false
    export let multi = false
    export let labeled = false
    export let htmlInput = null

    $: safeValue = multi ? (Array.isArray(value) ? value : []) : value

    function isSelected(v, sel) {
        if (multi) return sel.includes(v)
        return sel === v
    }

    function selectOption(opt) {
        if (disabled || opt.disabled) return
        if (multi) {
            const arr = Array.isArray(value) ? [...value] : []
            const index = arr.indexOf(opt.value)
            if (index >= 0) {
                arr.splice(index, 1)
            } else {
                arr.push(opt.value)
            }
            value = arr
        } else {
            value = opt.value
        }
        dispatch('change')
    }

    function onOptionKeydown(ev, opt) {
        if (ev.key === 'Enter' || ev.key === ' ') {
            ev.preventDefault()
            selectOption(opt)
        }
    }
</script>

<div class="zinput-inlineselect zinput_input zinput_input_labeled-{labeled}" bind:this={htmlInput}>
    {#each options as opt (opt.value)}
        <div
            class="zinput-inlineselect_opt"
            class:selected={isSelected(opt.value, safeValue)}
            class:disabled={disabled || opt.disabled}
            role="button"
            tabindex={disabled || opt.disabled ? -1 : 0}
            aria-pressed={isSelected(opt.value, safeValue)}
            on:click={() => selectOption(opt)}
            on:keydown={(ev) => onOptionKeydown(ev, opt)}
        >
            {opt.label}
        </div>
    {/each}
</div>

<style>
    .zinput-inlineselect {
        display: flex;
        align-items: stretch;
        gap: 4px;
        padding-left: 4px;
        padding-right: 4px;
    }

    .zinput-inlineselect_opt {
        flex: 1 1 0;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        padding: 0px 10px;
        border-radius: 8px;
        cursor: pointer;
        user-select: none;
        font-size: 14px;
        white-space: nowrap;
        transition: background-color 0.1s ease;
    }

    .zinput-inlineselect_opt:hover {
        background-color: #ffffff12;
    }

    :global(.theme_light) .zinput-inlineselect_opt:hover {
        background-color: #00000010;
    }

    .zinput-inlineselect_opt.selected {
        background-color: var(--bs-primary);
        color: #fff;
    }

    .zinput-inlineselect_opt.selected:hover {
        background-color: var(--bs-primary);
    }

    .zinput-inlineselect_opt.disabled {
        opacity: 0.4;
        cursor: not-allowed;
    }
</style>
